import React, { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SocketContext } from '../Context';
import useStyles from '../styles';

const VideoPlayer = () => {
  const { name, callAccepted, myVideo, userVideo, callEnded, stream, call } = useContext(SocketContext);
  const classes = useStyles();

  return (
    <Grid container className={classes.gridContainer2}>
      {stream && (
        <div className={classes.paper2}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>{name || 'Name'}</Typography>
            <video playsInline muted ref={myVideo} autoPlay className={classes.video} />
          </Grid>
        </div>
      )}
      {callAccepted && !callEnded && (
        <div className={classes.paper2}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>{call.name || 'Name'}</Typography>
            <video playsInline ref={userVideo} autoPlay className={classes.video} />
            {/* <div id="video-grid"> V</div> */}
          </Grid>
        </div>
      )}
    </Grid>
  );
};

export default VideoPlayer;
